export const paragraphStyle = {
  display: 'flex',
}
